import {
  appendRow,
  ensureTab,
  getRows,
  updateRow,
} from '../lib/googleSheets';

const TAB_TITLE = 'Configuration';

const HEADERS = [
  'id',
  'key',
  'value',
  'created_at',
  'updated_at',
];

function rowToConfig(row) {
  return HEADERS.reduce((config, header, index) => {
    config[header] = row?.[index] ?? '';
    return config;
  }, {});
}

function configToRow(config) {
  return HEADERS.map((header) => config[header] ?? '');
}

async function bootstrap() {
  await ensureTab(TAB_TITLE, HEADERS);
}

export async function getConfigurationRows() {
  await bootstrap();

  const rows = await getRows(`${TAB_TITLE}!A2:Z`);

  return rows
    .filter((row) => row?.[0])
    .map(rowToConfig);
}

export async function getConfigurationValue(key, fallback = '') {
  const configurations = await getConfigurationRows();
  const configuration = configurations.find((item) => (
    String(item.key).trim() === String(key).trim()
  ));

  return configuration ? configuration.value : fallback;
}

export async function setConfigurationValue(key, value) {
  await bootstrap();

  const rows = await getRows(`${TAB_TITLE}!A:Z`);
  const existingIndex = rows.findIndex((row, index) => (
    index > 0 && String(row?.[1]).trim() === String(key).trim()
  ));
  const now = new Date().toISOString();

  if (existingIndex > 0) {
    const sheetRow = existingIndex + 1;
    const existingRow = rows[existingIndex] || [];
    const existing = rowToConfig(existingRow);

    const updated = {
      id: existing.id,
      key,
      value: String(value),
      created_at: existing.created_at || now,
      updated_at: now,
    };

    await updateRow(
      `${TAB_TITLE}!A${sheetRow}:Z${sheetRow}`,
      configToRow(updated),
    );

    return updated;
  }

  const created = {
    id: crypto.randomUUID(),
    key,
    value: String(value),
    created_at: now,
    updated_at: now,
  };

  await appendRow(`${TAB_TITLE}!A:Z`, configToRow(created));

  return created;
}

export async function getMaintenanceMode() {
  const value = await getConfigurationValue('maintenance_mode', 'false');

  return String(value).trim().toLowerCase() === 'true';
}

export async function setMaintenanceMode(enabled) {
  return setConfigurationValue('maintenance_mode', enabled);
}